import { BindFancybox } from 'smg/fancybox';
import { SetBootstrapVersion } from 'smg/bootstrap';
import * as carts from 'smg/customer-api/v2/carts';
import { GetPageRequestID } from 'smg/customer-api/pagerequests';
import * as paypal from 'smg/customer-api/paypal';
import * as session from 'smg/customer-api/session';
import * as errors from 'smg/errors';
import * as html from 'smg/html';
import { SetIconLibrary } from 'smg/icons';
import * as meta from 'smg/meta';
import * as modals from 'smg/modal';
import QueryString from 'smg/querystring';
import { IncrementCartCount } from './carts';

// Carousel pause is rendered by layouts rather than a page module — lazy-load
// only when a riding carousel is present so other pages never download it.
if (document.querySelector('.carousel[data-bs-ride]')) {
    void import('./carousels').then(carousels => carousels.PauseOffscreenCarousels());
}

declare interface myWindow extends Window {
    metaPixel?: string;
}
declare const window: myWindow;

SetIconLibrary('fontAwesome5');
SetBootstrapVersion(5);

BindFancybox();

// No appendButtonClass: 'text-white' here — button text color belongs to
// color-contrast() via $min-contrast-ratio in app.scss (#8187): white on the
// blue btn-primary, black on the yellow btn-secondary. Forcing white broke
// every modal's gold cancel button.

errors.Defaults.showErrorFunc = msg => new modals.default({
    body: html.FromString(`<div>
            <i class="fas fa-exclamation-circle w-100 text-center mb-5 fa-5x text-danger"></i>
            <div class="fs-4 text-center">${html.Escape(msg)}</div>
        </div>`),
    cancelText: 'Close',
});

function initSession() {
    const navLogin = document.querySelector('#nav-login') as HTMLAnchorElement;
    const navLogout = document.querySelector('#nav-logout') as HTMLElement;
    const navOverview = document.querySelector('#nav-overview') as HTMLElement;

    const loginPageIds = ['login', 'login-email', 'join'];
    if (navLogin && !loginPageIds.includes(document.body.id)) {
        navLogin.addEventListener('click', e => {
            // A link that already names where to come back to (checkout's) keeps its own return.
            if (new URL(navLogin.href).searchParams.has('return')) {
                return;
            }
            e.preventDefault();
            const currentUrl = window.location.href;
            window.location.href = `${navLogin.href}?return=${encodeURIComponent(currentUrl)}`;
        });
    }

    if (session.GetLoginToken()) {
        session.Session().then(() => {
            navLogin.classList.add('d-none');
            navLogout.classList.remove('d-none');
            navOverview.classList.remove('d-none');

            // const navName = document.querySelector('#nav-name') as HTMLElement;
            // navName.textContent = `${sess.firstName} ${sess.lastName}`.trim() || sess.company || 'My Account';

            // const navSession = document.querySelector('#nav-session-item') as HTMLElement;
            // navSession.classList.remove('d-none');

            document.querySelectorAll('.logout').forEach(e => e.addEventListener('click', e => {
                e.preventDefault();

                session.DeleteSession();
                window.location.reload();
            }));
        }).catch(err => {
            navLogin?.classList.remove('d-none');
            throw err;
        });
    } else {
        navLogin.classList.remove('d-none');
        navLogout.classList.add('d-none');
        navOverview.classList.add('d-none');
    }
}

function initCart() {
    if (!carts.GetCartID()) {
        return;
    }
    carts.GetCartCount().then(count => {
        if (!count) {
            return;
        }

        IncrementCartCount(count);
    }).catch(err => console.error(`failed to get cart count: ${String(err)}`));
}

async function main() {
    await session.ConsumeLoginTokenFromURL();
    // Page tracking starts after the exchange so the page request belongs to the
    // account the link signed in, not whoever was signed in before.
    void GetPageRequestID();

    if (QueryString().get('paypal') === 'success') {
        const successAlert = document.querySelector('#paypal-success') as HTMLElement;
        successAlert.classList.remove('d-none');
        successAlert.addEventListener('closed.bs.alert', () => {
            successAlert.classList.add('d-none');
            QueryString().delete('paypal');
        });
    }

    if (QueryString().get('paypal') === 'error') {
        const successAlert = document.querySelector('#paypal-error') as HTMLElement;
        successAlert.classList.remove('d-none');
        successAlert.addEventListener('closed.bs.alert', () => {
            successAlert.classList.add('d-none');
            QueryString().delete('paypal');
        });
    }

    const paypalRetryURL = paypal.DeclinedRetryURL();
    if (paypalRetryURL) {
        const declinedAlert = document.querySelector('#paypal-declined') as HTMLElement;
        (declinedAlert.querySelector('#paypal-declined-retry') as HTMLAnchorElement).href = paypalRetryURL;
        declinedAlert.classList.remove('d-none');
        declinedAlert.addEventListener('closed.bs.alert', () => {
            declinedAlert.classList.add('d-none');
            QueryString().delete('paypal');
        });
    }

    if (QueryString().get('deleteCart')) {
        void carts.DeleteCart();
        QueryString().delete('deleteCart');
    }

    document.querySelector('.second-button')?.addEventListener('click', () => {
        document.querySelector('.animated-icon2')?.classList.toggle('open');
    });

    const dropdownMenus = Array.from(document.querySelectorAll('.dropdown-toggle')) as HTMLElement[];
    for (const dropdown of dropdownMenus) {
        dropdown.addEventListener('mouseover', () => {
            dropdown.classList.add('show');
            dropdown.nextElementSibling?.classList.add('show');
        });
        dropdown.nextElementSibling?.addEventListener('mouseover', () => {
            dropdown.classList.add('show');
            dropdown.nextElementSibling?.classList.add('show');
        });
        dropdown.parentElement?.parentElement?.addEventListener('mouseout', () => {
            dropdown.classList.remove('show');
            dropdown.nextElementSibling?.classList.remove('show');
        });
    }

    initSession();
    initCart();

    // Initialize Meta (Facebook) pixel tracking
    if (window.metaPixel) {
        const pixelId = window.metaPixel;
        void session.Session().then(sess => {
            meta.InitializeMeta(pixelId, sess ? {
                email: sess.user.emailAddress.email,
                phone: sess.user.phoneNumber.phone,
                userId: sess.user.id,
            } : undefined);
        }).catch(() => {
            meta.InitializeMeta(pixelId);
        }).finally(() => {
            meta.TrackPageView();
        });
    }
}

void main();
